<template>
  <div>
    <head-view></head-view>
    <div class="threeGameView">
      <img src="@/assets/img/20250213204801.png" alt="" />
      <h1>联系我们 :  mzsxkefu@mzsxgames.com</h1>
    </div>
  </div>
</template>
<script>
import headView from "../header/headView.vue";
export default {
  components: { headView },
};
</script>